export default class ExtensionChecker {
    static getVersion() {
        const marker = document.getElementById('os33-extension-present');
        let result = 'not installed';
        if (marker) {
            const version = marker.getAttribute('data-version');
            if (version) {
                result = version;
            }
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/scripts/services/extensionChecker.js